import { Box } from '@mui/material';
import { DateTime } from 'luxon';
import { FormattedRelativeTime } from 'react-intl';

interface CountdownProps {
  value: string | null | undefined;
}

export function Countdown({ value }: CountdownProps) {
  const countdownHours = value && Math.round(DateTime.fromISO(value).diffNow('hours').hours);

  if (!countdownHours || countdownHours <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        fontSize: '0.8rem',
        marginTop: 1,
        '&::first-letter': {
          textTransform: 'uppercase',
        },
      }}
    >
      <FormattedRelativeTime
        value={countdownHours > 24 ? Math.round(countdownHours / 24) : countdownHours}
        unit={countdownHours > 24 ? 'day' : 'hour'}
        numeric="always"
        style="long"
      />
    </Box>
  );
}
